export interface DateRange {
  fechaInicio: string;
  fechaFin: string;
}

export function getDateRangeUTC({ fechaInicio, fechaFin }: { fechaInicio: string, fechaFin: string }): DateRange {
  const start = new Date(fechaInicio + "T00:00:00");
  const end = new Date(fechaFin + "T23:59:59");
  // Conviertes a formato ISO siempre en UTC
  return {
    fechaInicio: start.toISOString(), // ej: "2025-10-20T05:00:00.000Z"
    fechaFin: end.toISOString()       // ej: "2025-10-21T04:59:59.999Z"
  };
}